import { render } from "./VoteInfo.vue?vue&type=template&id=0ef411b8"
import script from "./VoteInfo.vue?vue&type=script&lang=js"
export * from "./VoteInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__